import { TextProps } from '../Text';

type FlowStartCardInternalProps = {
  text?: TextProps;
};

type FlowStartCardPropsValues = {
  '': FlowStartCardInternalProps;
};

const propValues: FlowStartCardPropsValues = {
  '': {
    text: {
      type: 'LabelMedium',
      align: 'Left',
      style: 'Medium500',
      colour: 'NeutralHoverSelected',
    },
  },
};

const getProps = (type: string): FlowStartCardInternalProps => {
  const values: FlowStartCardInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
